import { useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation, Autoplay, Lazy, A11y } from "swiper";
import "swiper/swiper-bundle.css";
import sal from "sal.js";

SwiperCore.use([Navigation, Autoplay, Lazy, A11y]);

/* ===============================
   STATIC MANAGEMENT DATA
================================ */
const managementData = [
  {
    name: "Dr. Chitrakala Rajkumar",
    title: "Managing Director",
    qualifications: "Dr. Chitrakala Rajkumar graduated from Madras Medical College and trained in Internal Medicine in the U.K for 5 years. She is a healthcare entrepreneur with nearly 20 years of operational experience in executing several health care projects as the Managing Director of Lifeline Group of Hospitals and also with a key role in Stem cell research and therapy. As the Managing trustee of a charitable foundation run by the family, she has not only taken care of the medical and educational needs of HIV and cancer afflicted people but also involved in philanthropic causes",
    image_url: "/assets/img/management-1.webp",
  },
  {
    name: "Dr. Anirudh Rajkumar",
    title: "Joint Managing Director",
    qualifications: "Dr. Anirudh Rajkumar is one of the youngest Advanced Laparoscopic Surgeons and an active faculty at the Minimally Invasive Surgical Training Institute (MISTI), since 2015. He has trained nearly 500 surgeons as of December 2016. He is a certified Robotic Surgeon, who has performed more than 500 Laparoscopic surgeries.",
    image_url: "/assets/img/management-2.png",
  },
  {
    name: "Dr. K.P. Dinakaran",
    title: "Medical Administrator",
    qualifications: "A General Physician & Diabetologist by profession, Dr. Dinakaran has been associated with Lifeline since 2007. He has over 15 years of medical experience and plays the role of a medical administrator in the hospital making sure the hospital is up to date with state-of-the-art technologies and advance medical equipments among other things. He comes with previous experience as a medical administrator in various eminent hospitals in India and Maldives and repeatedly proves to be an asset to Lifeline.",
    image_url: "/assets/img/management-3.webp",
  },
  {
    name: "Ms. Shalini Wadhwa",
    title: "Senior Operations- Manager",
    qualifications: "Having graduated from Ethiraj College Chennai, Shalini Wadhwa started her career in the year 2000 at Rigid hospitals, now known as Lifeline Tulasi Hospital. Since then, she’s been playing a dynamic role as a Senior Manager in Operations making sure that the hospital runs with its fullest efficiency in every aspect. She also takes special care to ensure that good hospitality and genuine treatment is delivered to all the patients throughout their stay in the hospital",
    image_url: "/assets/img/management-4.png",
  },
];

const Management = () => {
  useEffect(() => {
    document.querySelectorAll(".doctor-card").forEach((card, index) => {
      card.setAttribute("data-sal", "slide-up");
      card.setAttribute("data-sal-duration", "1000");
      card.setAttribute("data-sal-delay", 100 + index * 200);
    });
    sal({ threshold: 0.2, once: true });
  }, []);

  const getSlidesPerView = (desired) => {
    return managementData.length < desired
      ? managementData.length
      : desired;
  };

  if (managementData.length === 0) return null;

  return (
    <section className="doctors-section">
      <h2
        className="section-title mb-3"
        data-sal="fade"
        data-sal-duration="1000"
        data-sal-delay="100"
      >
        Management
      </h2>

      <div className="container doctors-slider position-relative">
        <button type="button" className="slick-prev">
          <i className="fa-solid fa-chevron-left"></i>
        </button>
        <button type="button" className="slick-next">
          <i className="fa-solid fa-chevron-right"></i>
        </button>

        <Swiper
          navigation={{
            prevEl: ".slick-prev",
            nextEl: ".slick-next",
          }}
          autoplay={
            managementData.length > 4
              ? { delay: 7000, disableOnInteraction: false }
              : false
          }
          loop={managementData.length > 4}
          lazy
          a11y={{ enabled: true }}
          spaceBetween={20}
          slidesPerView={getSlidesPerView(4)}
          breakpoints={{
            992: { slidesPerView: getSlidesPerView(4) },
            768: { slidesPerView: getSlidesPerView(2) },
            0: { slidesPerView: getSlidesPerView(1) },
          }}
          onInit={(swiper) => setTimeout(() => swiper.update(), 50)}
          className="gastro-doctors-swiper"
        >
          {managementData.map((person, idx) => (
            <SwiperSlide key={idx}>
              <div className="doctor-card">
                <img
                  src={person.image_url}
                  alt={person.name}
                  className="doctor-img"
                  loading="lazy"
                />
                <div className="doctor-info">
                  <div>
                    <h5>{person.title}</h5>
                    <h3>{person.name}</h3>
                    <p className="qualifications">
                      {person.qualifications}
                    </p>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default Management;
